module.exports = __webpack_public_path__ + "media/images/emblems/Tevenon-coat_of_arms-61eb509d492c59456a28371acd54abd0.svg";